// src/pages/pedidos/TaxaEntregaCad.js
import React, { useState, useEffect } from 'react';

import TaxaEntregaSearch from './TaxaEntregaSearch';
import { TaxaEntrega } from '../../models/pedidos/TaxaEntrega';
import { useTaxaEntrega } from '../../contexts/pedidos/TaxaEntregaContext';
import Input from '../../components/input/Input';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useYesNo } from '../../contexts/geral/YesNoContext';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalHeader from '../../components/modalForm/ModalHeader';
import InputCheck from '../../components/input/InputCheck';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const TaxaEntregaCad = ({ show, onHide }) => {
    const { taxasEntrega, addTaxaEntrega, updateTaxaEntrega, deleteTaxaEntrega } = useTaxaEntrega();
    const [taxaEntrega, setTaxaEntrega] = useState(new TaxaEntrega());
    const [showSearchModal, setShowSearchModal] = useState(false);
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setTaxaEntrega(new TaxaEntrega());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione uma Taxa de Entrega para editar!");
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!taxaEntrega?.id) {
            showMessage("Selecione uma Taxa de Entrega para excluir!");
        } else {
            const resposta = await showYesNo("Deseja excluir a taxa de entrega selecionada?");
            if (resposta) {
                await deleteTaxaEntrega(taxaEntrega.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            // if (!taxaEntrega.limiteKm) {
            //     showMessage("Informe um limite de km para a taxa de entrega!");
            //     return;
            // }
            if (!taxaEntrega.valor) {
                showMessage("Informe um valor para a taxa de entrega!");
                return;
            }

            if (!taxaEntrega.id) {
                await addTaxaEntrega(taxaEntrega);
            } else {
                await updateTaxaEntrega(taxaEntrega);
            }
            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
        }
    };

    const handleExit = () => {
        const taxaSel = taxasEntrega.find(c => c.id.toString() === taxaEntrega?.id?.toString());

        if (taxaSel) {
            setTaxaEntrega(taxaSel);
            handleEditar(taxaEntrega?.id);
        } else {
            setTaxaEntrega(new TaxaEntrega());
        }
    };

    const handleSelectTaxaEntrega = (taxaSel) => {
        setTaxaEntrega(taxaSel);
        setShowSearchModal(false);
        if (taxaSel) {
            handleEditar(taxaSel.id);
        } else {
            setTaxaEntrega(new TaxaEntrega());
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Nova Taxa de Entrega' : 'Alterar Taxa de Entrega'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={taxaEntrega.id || ''}
                            onChange={(e) => setTaxaEntrega({ ...taxaEntrega, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />

                        <Input
                            label="Limite de Km"
                            type="number"
                            value={taxaEntrega?.limiteKm || ''}
                            onChange={(e) => setTaxaEntrega({ ...taxaEntrega, limiteKm: parseFloat(e.target.value) })}
                        />

                        <Input
                            label="Valor"
                            type="number"
                            value={taxaEntrega?.valor || ''}
                            onChange={(e) => setTaxaEntrega({ ...taxaEntrega, valor: parseFloat(e.target.value) })}
                        />

                        <InputCheck
                            label="Padrão"
                            checked={taxaEntrega.valorDefault}
                            onChange={(e) => setTaxaEntrega({ ...taxaEntrega, valorDefault: e.target.checked })}
                        />

                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <TaxaEntregaSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectTaxaEntrega={handleSelectTaxaEntrega}
            />
        </ModalContainer>
    );
};

export default TaxaEntregaCad;